import React from "react";
import { ProducerPreviewMostPopularContentTemplate } from "themes/administration/producer/components";

function ProducerPreviewMostPopularContent(props) {
    return <ProducerPreviewMostPopularContentTemplate {...props} />;
}

export default ProducerPreviewMostPopularContent;
